import Vue from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'

import { faAddressBook, faAngleLeft, faBan, faBell, faCheck, faCheckSquare, faCloud, faDownload, faEdit, faEnvelope,
    faEraser, faExchangeAlt, faEye, faList, faLock, faLockOpen, faMinus, faPaperPlane, faPhone, faPlus, faQuestionCircle,
    faSave, faSearch, faSignature, faSignOutAlt, faTimes, faToggleOff, faToggleOn, faTrashAlt, faUpload, faUser, faUsers,
    faUserCircle } from '@fortawesome/free-solid-svg-icons'

library.add(faAddressBook, faAngleLeft, faBan, faBell, faCheck, faCheckSquare, faCloud, faDownload, faEdit, faEnvelope,
    faEraser, faExchangeAlt, faEye, faList, faLock, faLockOpen, faMinus, faPaperPlane, faPhone, faPlus, faQuestionCircle,
    faSave, faSearch, faSignature, faSignOutAlt, faTimes, faToggleOff, faToggleOn, faTrashAlt, faUpload, faUser, faUsers,
    faUserCircle);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);
Vue.component('font-awesome-layers-text', FontAwesomeLayersText);